import request from '../kernel/request'

export default {
	point: {
		page(params) {
			return request.get('point/page', params)
		},
		load(id) {
			return request.get('point/' + id)
		},
	}
	}